import styled, { keyframes } from 'styled-components'
import { ISkeletonProps } from './skeleton.types'

export const skeletonAnimation = keyframes`
  to {
    background-position-x: -200%;
  }
`

export const Skeleton = styled.div<ISkeletonProps>`
  width: ${({ width }) => (width ? width : '100%')};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '100%')};
  height: ${({ height }) => (height ? height : '24px')};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '1px')};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0')};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0')};
  overflow: hidden;

  background-image: linear-gradient(90deg, #e5e3e3 8%, #f2f2f2 18%, #e5e3e3 33%);
  background-size: 200% 100%;

  animation-name: ${skeletonAnimation};
  animation-duration: 2s;
  animation-delay: 0;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`
